// extracted by mini-css-extract-plugin
export default {"tiledSelect":"index_tiledSelect__4XdwW"};